<app-loading-spinner [active]="loading"></app-loading-spinner>

<form [formGroup]="form">
    <div class="row no-gutters w-100">
        <div class="col-12 col-lg-10">
            <div class="row" *ngIf="data.length === 0">
                <div class="col-12">
                    <div class="info-message">
                        <svg-icon src="assets/images/icon-info.svg"></svg-icon>
                        <span>
                            É necessário adicionar pelo menos um fundo de
                            interesse.
                        </span>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </div>
        </div>
    </div>

    <div class="row no-gutters w-100">
        <div class="col-12 col-lg-10">
            <ng-container *ngIf="showForm">
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <app-select label="Fundo de interesse" [group]="form"
                            [readOnly]="needInviteFund" controlName="fund"
                            [items]="fundOptions">
                        </app-select>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 col-lg-4" *ngIf="isAssignor">
                        <app-spacer [top]="4"></app-spacer>
                        Possuí coobrigação com o fundo?
                        <app-spacer [bottom]="16"></app-spacer>

                        <div class="d-flex">
                            <app-radio
                                [isChecked]="form.controls.co_obligation.value === true"
                                (onCheckChanged)="handleCoObligationClick($event, true)">
                                Sim
                            </app-radio>
                            <app-spacer [right]="32"></app-spacer>
                            <app-radio
                                [isChecked]="form.controls.co_obligation.value === false"
                                (onCheckChanged)="handleCoObligationClick($event, false)">
                                Não
                            </app-radio>
                        </div>
                        <!-- <app-radio
                            [isChecked]="form.controls[option.formControl].value === suboption.value"
                            [formControlName]="option.formControl"
                            [value]="suboption.value">
                            <div class="flex-1 d-flex flex-column">
                                <span
                                    class="basic-content-description"><strong>{{i+1}})</strong>
                                    {{suboption.label}}</span>
                            </div>
                        </app-radio> -->


                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-6 d-flex">
                        <app-button (onClick)="triggerForm()"
                            [loading]="sending" [disabled]="getDisabled()"
                            class="add-button mr-3" [outline]="true">
                            <svg-icon src="assets/images/icon-add.svg"
                                class="mr-2"></svg-icon>
                            Salvar interesse
                        </app-button>

                        <app-button *ngIf="data.length > 0"
                            (onClick)="handleCancel()" class="add-button"
                            [outline]="true">
                            Cancelar
                        </app-button>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="!showForm">
                <div class="row no-gutters" *ngIf="data.length > 0">
                    <div class="col-12">
                        <table class="app-table">
                            <thead class="app-table-head">
                                <tr class="app-table-head-row">
                                    <th>Fundo de interesse</th>
                                    <th *ngIf="isAssignor">Possuí
                                        coobrigação</th>
                                    <th></th>
                                </tr>
                            </thead>

                            <tbody class="app-table-body">
                                <tr *ngFor="let item of data; let i = index"
                                    class="app-table-body-row">
                                    <td>
                                        {{item.fund.name}} |
                                        {{formatCnpj(item.fund.document)}}
                                    </td>
                                    <td *ngIf="isAssignor">
                                        {{item.co_obligation ? 'Sim' : 'Não'}}
                                    </td>
                                    <td class="d-flex">
                                        <app-tooltip text="Excluir"
                                            position="top">
                                            <button class="app-table-remove"
                                                (click)="removeInterest(i)">
                                                <svg-icon
                                                    src="assets/images/icon-trash.svg"></svg-icon>
                                            </button>
                                        </app-tooltip>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <app-spacer [bottom]="32"></app-spacer>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-6">
                        <app-button *ngIf="data.length > 0"
                            (onClick)="triggerForm()" class="add-button"
                            [outline]="true">
                            <svg-icon src="assets/images/icon-add.svg"
                                class="mr-2"></svg-icon>
                            Adicionar outro fundo
                        </app-button>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>

    <app-side-modal [active]="addAnotherModal"
        title="Adicionar fundo de interesse" (onClose)="handleCloseModal()"
        paddingBottom="0">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-12">
                    <app-select label="Fundo de interesse" [group]="form"
                        [readOnly]="needInviteFund" controlName="fund"
                        [items]="fundOptions">
                    </app-select>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>

                <div class="col-12" *ngIf="isAssignor">
                    <app-spacer [top]="4"></app-spacer>
                    Possuí coobrigação com o fundo?
                    <app-spacer [bottom]="16"></app-spacer>

                    <div class="d-flex">
                        <app-radio
                            [isChecked]="form.controls.co_obligation.value === true"
                            (onCheckChanged)="handleCoObligationClick($event, true)">
                            Sim
                        </app-radio>
                        <app-spacer [right]="32"></app-spacer>
                        <app-radio
                            [isChecked]="form.controls.co_obligation.value === false"
                            (onCheckChanged)="handleCoObligationClick($event, false)">
                            Não
                        </app-radio>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </div>

            <div class="row button-sticky">
                <div class="col-12 col-lg-6">
                    <app-button (onClick)="handleCloseModal()"
                        class="add-button" [outline]="true">
                        Cancelar
                    </app-button>
                </div>

                <div class="col-12 col-lg-6">
                    <div class="text-right">
                        <app-button (onClick)="triggerForm()"
                            [loading]="sending" [disabled]="getDisabled()"
                            class="add-button">
                            Salvar interesse
                        </app-button>
                    </div>
                </div>
            </div>
        </div>
    </app-side-modal>
</form>